export const daysRangeOptions = [
  { value: 10, label: "10 Days", short_label: "10D", chart_height: 250 },
  { value: 30, label: "1 Month", short_label: "1M", chart_height: 600 },
  { value: 60, label: "2 Months", short_label: "2M", chart_height: 900 },
  { value: 90, label: "3 Months", short_label: "3M", chart_height: 1200 },
  //{ value: 180, label: "6 Months", short_label: "6M" },
  //{ value: 365, label: "1 Year", short_label: "1Y" },
];
